import React, { useEffect, useState } from "react";
import Header from "../component/menu/Header";
import { CharLimit, constants } from "../constant/constants";
import SideMenu from "../component/menu/SideMenu";
import { getParsedNumber } from "../utils/Common";
import { Button, Select, Spin } from "antd";
import ConfirmationModal from "../component/modals/ConfirmationModal";
import ViewFoodModal from "../component/modals/ViewFoodModal";
import useUserStore from "../stores/store";
import ApiService from "../utils/ApiService";
import AddSetFoodMenuModal from "../component/modals/AddSetFoodMenuModal";
import CustomLoader from "../component/menu/CustomLoader";
import TextArea from "antd/es/input/TextArea";
import { CheckCircleFilled } from "@ant-design/icons";
import { useNavigate } from "react-router-dom";
import ImageUploadWithCropAndWebp from "../component/common/ImageUploadWithCropAndWebp";
import CustomInputNumberV2 from "../component/CustomInputNumberV2";
import FoodTaxAndDiscount from "../component/restaurants/foods/FoodTaxAndDiscount";
import CustomInputNumber from "../component/CustomInputNumber";

function SetMenu() {
  // eslint-disable-next-line no-unused-vars
  const [confirmationMessage, setConfirmationMessage] = useState("");
  // eslint-disable-next-line no-unused-vars
  const [action, setAction] = useState("");

  const [upsertLoading, setUpsertLoading] = useState(false);
  const navigate = useNavigate();

  // eslint-disable-next-line no-unused-vars
  const [currentPage, setCurrentPage] = useState(1);
  // eslint-disable-next-line no-unused-vars
  const [selectedItem, setSelectedItem] = useState({});

  // eslint-disable-next-line no-unused-vars
  const [perPage, setPerPage] = useState(5000);
  const { user, restaurantId, showNotification } = useUserStore();
  const [checkedItems, setCheckedItems] = useState({});
  const [isComboModalOpen, setIsComboModalOpen] = useState(false);
  const [isConfirmModalOpen, setIsConfirmModalOpen] = useState(false);
  const [isViewModalOpen, setIsViewModalOpen] = useState(false);
  const [price, setPrice] = React.useState("");
  const [discount, setDiscount] = React.useState("");
  const [discountType, setDiscountType] = React.useState("%");
  const [categoryList, setCategoryList] = useState([]);
  const [categoryDropdownList, setCategoryDropdownList] = useState([]);
  const [categoryId, setCategoryId] = useState([]);
  const [categoryName, setCategoryName] = useState("");
  const [comboName, setComboName] = useState("");
  const [defaultQuantity, setDefaultQuantity] = useState("");
  const [croppedFile, setCroppedFile] = useState(null);
  const [fileList, setFileList] = useState([]);
  const [description, setDescription] = useState("");
  const [comboFoods, setComboFoods] = useState([]);
  const [selectedItems, setSelectedItems] = useState({});
  const [addOns, setAddOns] = useState([
    {
      name: "",
      price: "",
    },
  ]);
  const [filter, setFilter] = useState({
    restaurantId: "",
    searchText: "",
    sortBy: "NEWEST",
    page: 1,
    perPage: perPage,
  });

  const [isVatApplicable, setIsVatApplicable] = useState(true);
  const [isDiscountApplicable, setIsDiscountApplicable] = useState(true);
  const [isSupplementaryDutyApplicable, setIsSupplementaryDutyApplicable] = useState(false);
  const [supplementaryDuty, setSupplementaryDuty] = useState("");

  const onChangeCategory = (value) => {
    const category = categoryList.find((cat) => cat.id === value);

    setCategoryId(value);
    setCategoryName(category ? category.name : "");

    const options = category
      ? category.options.map((item) => ({
          optionId: item._id,
          name: item.name,
          price: 0,
        }))
      : [];
  };

  useEffect(() => {}, [checkedItems]);

  const onClickSaveButtonInModal = (response) => {
    setCheckedItems(response);
    if (response.comboMenuFoods && response.comboMenuFoods.length > 0) {
      showNotification("Food added for Combo Menu", false);
    }
  };

  const onClickCancelButtonInModal = (items) => {
    setIsComboModalOpen(false);
  };

  // eslint-disable-next-line no-useless-rename

  const updateOptionName = (index, val) => {
    setAddOns((previousOption) => previousOption.map((item, i) => (index === i ? { ...item, name: val } : item)));
  };

  const addMoreOption = () => {
    let param = {
      name: "",
      price: "",
    };
    setAddOns(() => [...addOns, param]);
  };

  const removeOption = (index) => {
    setAddOns(() => [...addOns.slice(0, index), ...addOns.slice(index + 1)]);
  };

  useEffect(() => {
    fetchComboFoodList();
    fetchComboCategoryList();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []); // Add empty dependency array to run only once

  const fetchComboFoodList = async () => {
    const status = "Active";
    const params = { restaurantId, status, perPage };
    try {
      const response = await ApiService.FILTER_FOOD_LIST(params, user.token.token);

      if (response?.payload?.foodItems) {
        setComboFoods(response.payload.foodItems);
      } else {
        setComboFoods([]);
      }
    } catch (error) {
      console.error("Error fetching related items:", error);
    }
  };

  const fetchComboCategoryList = async () => {
    const isSetMenu = "YES";
    try {
      const res = await ApiService.GET_CATEGORY({ restaurantId, isSetMenu }, user.token.token);

      if (res.status === "ok") {
        const data = res.payload.records;

        setCategoryList(data);

        const items = data.map((item) => ({
          value: item.id,
          label: item.name,
        }));

        setCategoryDropdownList(items);
      }
    } catch (error) {
      console.error("Error fetching related items:", error);
    }
  };

  const onConfirm = (record, action) => {
    setIsConfirmModalOpen(false);
    orderStatusChange(record, action === constants.FOOD.ACTIVE ? constants.FOOD.ACTIVE : constants.FOOD.INACTIVE);
  };

  const onNotConfirm = () => {
    setIsConfirmModalOpen(false);
  };

  const orderStatusChange = async (record, selection = "Inactive") => {
    let food = await ApiService.FOOD_STATUS_CHANGE(
      {
        restaurantId,
        foodId: record._id,
        selection,
      },
      user.token.token,
    );

    if (food.code !== 200) {
      return;
    }
  };

  const onCloseViewModal = () => {
    setIsViewModalOpen(false);
  };

  const updateQuantity = (newQty, index) => {
    setCheckedItems((prevState) => {
      const updatedItems = [...prevState.comboMenuFoods];
      updatedItems[index].quantity = newQty;
      return { ...prevState, comboMenuFoods: updatedItems };
    });

    setSelectedItems((prevSelectedItems) => {
      const updatedItems = { ...prevSelectedItems };
      const foodId = Object.keys(updatedItems)[index];
      updatedItems[foodId].quantity = newQty;
      return updatedItems;
    });
  };

  const handleQuantityChange = (nameValObj) => {
    const [index, field] = nameValObj.name.split("_");
    updateQuantity(nameValObj.value, index);
  };

  const onClickComboMenu = () => {
    setIsComboModalOpen(true);
  };

  const resetComboMenu = () => {
    setCategoryName("");
    setCategoryList([]);
    setCategoryId(null);
    setComboName("");
    setDefaultQuantity("");
    setCroppedFile(null);
    setFileList([]);
    setDescription("");
    setAddOns([{ name: "", price: "" }]);
    setCheckedItems({});
    setPrice("");
    setDiscount("");
    setDiscountType("%");
    setSelectedItems({});

    // Redirect to the food list page
    navigate("/food?menu=combo");
  };

  const onClickSaveComboMenu = async () => {
    const sanitizedAddOns = addOns.filter((addOn) => addOn.name || addOn.price);

    const comboMenuData = {
      restaurantId,
      categoryId,
      categoryName,
      comboName,
      defaultQuantity,
      croppedFile,
      description,
      addOns: sanitizedAddOns.length ? sanitizedAddOns : [],
      comboFoods: checkedItems.comboMenuFoods || [],
      price,
      discount,
      discountType,
    };

    if (!comboMenuData.restaurantId) {
      showNotification("Please fill in the restaurant ID.");
      return;
    }

    if (!comboMenuData.categoryId) {
      showNotification("Please select a category.");
      return;
    }

    if (!comboMenuData.comboName) {
      showNotification("Please fill in the combo name.");
      return;
    }

    if (!comboMenuData.description) {
      showNotification("Please fill in the description details.");
      return;
    }

    // Image is optional
    // if (!comboMenuData.croppedFile) {
    //     showNotification("Please upload an image.");
    //     return;
    // }

    const includedFood = {
      includes: comboMenuData.comboFoods.map((food) => ({
        foodId: food.foodId,
        optionId: food.optionId,
        quantity: food.quantity,
      })),
    };
    /*check total quantity of selected foods*/
    if (getTotalQuantity(includedFood) < 2) {
      showNotification("Combo foods must contain at least two item.");
      return;
    }

    for (let addOn of comboMenuData.addOns) {
      if ((addOn.name && !addOn.price) || (!addOn.name && addOn.price)) {
        showNotification("Please fill in both name and price for add-ons or leave both empty.");
        return;
      }
    }

    if (comboMenuData.price <= 0) {
      showNotification("Price must be greater than zero.");
      return;
    }

    if (comboMenuData.discountType === "%" && comboMenuData.discount > 100) {
      showNotification("Discount percentage must be less than or equal 100.");
      return;
    }

    if (
      comboMenuData.discountType === "BDT" &&
      getParsedNumber(comboMenuData.discount) > getParsedNumber(comboMenuData.price)
    ) {
      showNotification("Discount amount can't be greater than the price.");
      return;
    }

    const formData = new FormData();

    formData.append("restaurantId", comboMenuData.restaurantId);
    formData.append("categoryId", comboMenuData.categoryId);
    formData.append("name", comboMenuData.comboName);
    formData.append("details", comboMenuData.description);
    if (comboMenuData.croppedFile) {
      formData.append("image", comboMenuData.croppedFile);
    }

    formData.append("defaultQuantity", comboMenuData.defaultQuantity);

    const priceDetails = {
      amount: comboMenuData.price,
      discount: comboMenuData.discount,
      isDiscountInPercent: comboMenuData.discountType === "%" ? "YES" : "NO",
    };
    formData.append("price", JSON.stringify(priceDetails));

    formData.append("setMenuAddOn", JSON.stringify({ addOns: comboMenuData.addOns }));

    formData.append("includedFood", JSON.stringify(includedFood));

    formData.append("isVatApplicable", isVatApplicable ? "YES" : "NO");
    formData.append("isDiscountApplicable", isDiscountApplicable ? "YES" : "NO");
    formData.append("isSupplementaryDutyApplicable", isSupplementaryDutyApplicable ? "YES" : "NO");
    formData.append("supplementaryDuty", isSupplementaryDutyApplicable ? supplementaryDuty : 0);

    try {
      setUpsertLoading(true);

      const response = await ApiService.ADD_SET_FOODS(formData, user.token.token);

      console.log("*****response****", response);

      if (response.code === 200) {
        showNotification("Combo Menu created successfully!", false);
        resetComboMenu();
      } else {
        showNotification(response.data.message);
      }
    } catch (error) {
      showNotification("Something went wrong!");
    } finally {
      setUpsertLoading(false);
    }
  };

  const deleteImage = async () => {
    setFileList([]);
    setCroppedFile(null);
    return;
  };

  useEffect(() => {
    setFilter({
      ...filter,
      restaurantId,
      page: currentPage,
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [currentPage, restaurantId]); // Add necessary dependencies

  const handleRemoveItem = (index) => {
    const updatedComboFoods = checkedItems.comboMenuFoods.filter((item, i) => i !== index);
    setCheckedItems({ ...checkedItems, comboMenuFoods: updatedComboFoods });

    setSelectedItems((prevSelectedItems) => {
      const updatedItems = { ...prevSelectedItems };
      const foodId = Object.keys(prevSelectedItems)[index];
      delete updatedItems[foodId];
      return updatedItems;
    });
  };

  const onChangeAddOnsPrice = (nameValObj) => {
    const [index, field] = nameValObj.name.split("_");
    const val = nameValObj.value;

    setAddOns((prev) => prev.map((item, i) => (i == index ? { ...item, price: val } : item)));
  };

  const handlePrice = (value) => {
    setPrice(value);
  };

  const handleDiscountChange = (val) => {
    if (discountType !== "%") {
      setDiscount(val);
    }

    if (discountType === "%" && parseFloat(val) <= 100) {
      setDiscount(val);
    }
  };

  const onHandleDiscountTypeChange = (val) => {
    setDiscountType(val);

    if (val === "%" && getParsedNumber(discount) > 100) {
      setDiscount("");
    }
  };

  function getTotalQuantity(items) {
    if (!Array.isArray(items.includes)) return 0;

    return items.includes.reduce((total, item) => {
      return total + (item.quantity || 0);
    }, 0);
  }

  const handleDescription = (e) => {
    const value = e.target.value;
    if (value.length > CharLimit.Details) return;
    setDescription(value);
  };

  return (
    <div className="flex flex-col">
      <CustomLoader />
      <Header title={`McDonalds Food Chain`} menu={constants.MENU.FOOD} currentMenuKey={"T_3_S_3"} />
      <div className="flex flex-row bg-prewhite">
        <SideMenu title={`McDonalds Food Chain`} menu={constants.MENU.FOOD} />
        <div className="flex flex-row p-[24px] w-full mt-[80px] ml-[72px]">
          <div className="flex flex-col w-full">
            <div className="flex flex-row">
              <div className="flex flex-row mb-[16px] font-uregular p-[16px] w-full items-center justify-between">
                <div className="font-ubold text-xl">Add Set Menu / Combo</div>
                <div
                  className="px-[16px] py-[8px] rounded bg-yellow text-md font-ubold cursor-pointer"
                  onClick={() => navigate("/food?menu=combo")}
                >
                  List
                </div>
              </div>
            </div>

            <div className="bg-white pt-[20px] pb-[10px]">
              <div className="bg-white pt-[10px] pb-[10px]">
                {/* Add-Ons block */}
                <div className="flex flex-row justify-between items-center gap-[20px] pl-[25px] pb-[20px] pr-[25px]">
                  <div className="flex" style={{ width: "49%" }}>
                    <Select
                      className="w-[100%]"
                      onChange={onChangeCategory}
                      showSearch
                      placeholder="Category"
                      filterOption={(input, option) =>
                        (option?.label ?? "").toLowerCase().includes(input.toLowerCase())
                      }
                      options={categoryDropdownList}
                      value={categoryId}
                    />
                    <p className="text-red-500 top-3 ml-2">*</p>
                  </div>
                  <div className="w-1/4 flex flex-col h-[105px]">
                    <ImageUploadWithCropAndWebp
                      fileList={fileList}
                      setFileList={(files) => {
                        if (!files || files.length < 1) {
                          return;
                        }

                        setCroppedFile(files[0].originFileObj);
                        setFileList(files);
                      }}
                      deleteImage={deleteImage}
                      minWidth={500}
                    />
                  </div>
                </div>

                <div className="flex flex-row justify-between items-center gap-[20px] pl-[25px] pb-[20px] pr-[25px]">
                  <div className="flex" style={{ width: "49%" }}>
                    <input
                      value={comboName}
                      onChange={(e) => setComboName(e.target.value)}
                      className="rounded-[5px] border-[1px] border-grey font-uregular px-[8px] py-[4px] w-full"
                      placeholder="Combo Name"
                    />
                    <p className="text-red-500 top-3 ml-2">*</p>
                  </div>
                </div>

                <div className="flex flex-row justify-between items-center gap-[20px] pl-[25px] pb-[20px] pr-[25px]">
                  <div className="w-2/4">
                    <div className="flex">
                      <TextArea
                        rows={2}
                        value={description}
                        onChange={handleDescription}
                        className="rounded-[5px] border-[1px] border-grey font-uregular px-[8px] py-[4px] w-full"
                        placeholder="Enter Description (Max 2000 chacters)"
                      />
                      <p className="text-red-500 top-3 ml-2">*</p>
                    </div>

                    <div className="mt-1 text-[12px] text-gray-600 italic">Char limit 2000 ({description.length})</div>
                  </div>

                  <div className="w-2/4 flex flex-col">
                    <Button
                      type="primary"
                      onClick={onClickComboMenu}
                      className="w-full mt-[16px] h-[40px] text-white border-none"
                      style={{
                        backgroundColor: "#FFD700",
                        color: "#000000",
                        fontFamily: "ubold",
                      }}
                    >
                      Select Food List <p className="text-red-500 top-3 ml-2">*</p>
                    </Button>

                    <AddSetFoodMenuModal
                      openModal={isComboModalOpen}
                      records={{
                        onFinish: onClickSaveButtonInModal,
                        onCancel: onClickCancelButtonInModal,
                        comboFoods: comboFoods,
                      }}
                      selectedItems={selectedItems}
                      setSelectedItems={setSelectedItems}
                    />
                  </div>
                </div>

                {checkedItems.comboMenuFoods && checkedItems.comboMenuFoods.length > 0 && (
                  <div className="flex items-center pl-[25px] pb-[20px] pr-[25px]">
                    <span className="mr-4">Combo Items</span>
                    <div className="flex-grow h-px bg-gray-300"></div>
                  </div>
                )}
                <div className="pl-[25px] pr-[25px]">
                  {checkedItems.comboMenuFoods?.map((item, index) => (
                    <div
                      className="flex flex-row justify-between items-center gap-[20px] pl-[25px] pb-2 pt-2 pr-[25px] bg-gray-100 mb-2"
                      key={index}
                    >
                      <div className="w-2/4 flex items-center break-all">
                        <CheckCircleFilled style={{ color: "#FFD700", fontSize: "16px", marginRight: "8px" }} />
                        <p className="m-0">{item.foodName}</p>
                      </div>
                      <div className="w-2/4 break-all flex flex-col">
                        <p>{item.optionName === "System Default" ? "" : item.optionName}</p>
                      </div>
                      <div className="w-[150px] flex flex-col">
                        <div className="flex items-center gap-[10px]">
                          <p className="text-sm">QTY</p>
                          <CustomInputNumber
                            name={`${index}_qty`}
                            value={item.quantity || 1}
                            setValue={handleQuantityChange}
                            min={1}
                            max={99}
                            shouldSetValueSetObj={true}
                          />
                        </div>
                      </div>
                      <div className="flex items-center justify-end">
                        <img
                          onClick={() => handleRemoveItem(index)}
                          className="w-[27px] h-[16px] cursor-pointer"
                          src="/images/remove.svg"
                          alt="Remove"
                        />
                      </div>
                    </div>
                  ))}
                </div>

                <div className="flex items-center pl-[25px] pb-[20px] pr-[25px]">
                  <span className="mr-4">Add-Ons</span>
                  <div className="flex-grow h-px bg-gray-300"></div>
                </div>

                {addOns.map((item, index) => (
                  <div className="flex flex-row justify-between items-center pb-[20px] pr-[25px]" key={index}>
                    <div className="flex flex-col pl-[20px]" style={{ width: "49%" }}>
                      <input
                        value={addOns[index].name}
                        onChange={(e) => updateOptionName(index, e.target.value)}
                        className="rounded-[5px] border-[1px] border-grey font-uregular px-[8px] py-[4px]"
                        placeholder="Add-Ons"
                      />
                    </div>
                    <div className="flex flex-col" style={{ width: "45%" }}>
                      {/* <input
                        type="number"
                        value={addOns[index].price}
                        onChange={(e) => {
                          const value = e.target.value;
                          setAddOns((previousOption) =>
                            previousOption.map((item, i) =>
                              index === i ? { ...item, price: value === '' ? '' : Math.max(1, parseInt(value, 10)) } : item
                            )
                          );
                        }}
                        className="rounded-[5px] border-[1px] border-grey font-uregular px-[8px] py-[4px]"
                        placeholder="Price"
                      /> */}
                      {/* <input
                        type="text"
                        inputMode="decimal"
                        pattern="^\d*\.?\d{0,2}$"
                        value={addOns[index].price}
                        onChange={(e) => {
                          const rawValue = e.target.value;

                          // Allow empty input
                          if (rawValue === "") {
                            setAddOns((prev) => prev.map((item, i) => (i === index ? { ...item, price: "" } : item)));
                            return;
                          }

                          // Allow only numbers with optional one decimal and max 2 digits after dot
                          if (!/^(\d+)?(\.\d{0,2})?$/.test(rawValue)) return;

                          const parsedValue = parseFloat(rawValue);

                          // Prevent values > 99999
                          if (parsedValue > 99999) return;

                          setAddOns((prev) =>
                            prev.map((item, i) => (i === index ? { ...item, price: rawValue } : item))
                          );
                        }}
                        className="rounded-[5px] border-[1px] border-grey font-uregular px-[8px] py-[4px]"
                        placeholder="Price"
                      /> */}
                      <CustomInputNumberV2
                        name={`${index}_addOnsPrice`}
                        shouldSetValueSetObj={true}
                        placeholder={""}
                        addonBefore="Price"
                        value={addOns[index].price}
                        setValue={onChangeAddOnsPrice}
                        isDecimalAllowed={true}
                        max={99999}
                        min={0}
                      />
                    </div>
                    <div className="flex items-center justify-center h-full">
                      {index === addOns.length - 1 ? (
                        <img
                          onClick={addMoreOption}
                          className="w-[16px] h-[16px] cursor-pointer"
                          src={"/images/plus.svg"}
                          alt="Add"
                        />
                      ) : (
                        <img
                          onClick={() => removeOption(index)}
                          className="w-[16px] h-[16px] cursor-pointer"
                          src={"/images/remove.svg"}
                          alt="Remove"
                        />
                      )}
                    </div>
                  </div>
                ))}

                <div className="flex items-center pl-[25px] pb-[20px] pr-[25px]">
                  <div className="flex-grow h-px bg-gray-300"></div>
                </div>

                <div className="flex flex-col pl-[25px] pb-[20px] pr-[25px]">
                  <div className="flex w-full">
                    <div className="flex ml-auto" style={{ width: "49%" }}>
                      <CustomInputNumberV2
                        placeholder={""}
                        addonBefore="Set Menu Price"
                        value={price}
                        setValue={handlePrice}
                        isDecimalAllowed={true}
                        max={99999}
                        min={0}
                      />
                      <p className="text-red-500 top-3 ml-2">*</p>
                    </div>
                  </div>

                  <div className="flex w-full mt-[20px]">
                    <div className="ml-auto flex items-center gap-[10px]" style={{ width: "49%" }}>
                      <div className="flex-[7]">
                        <CustomInputNumberV2
                          placeholder={""}
                          addonBefore="Discount"
                          value={discount}
                          setValue={handleDiscountChange}
                          isDecimalAllowed={true}
                          max={99999}
                          min={0}
                        />
                      </div>

                      <div className="flex-[3]">
                        <Select
                          value={discountType}
                          onChange={(value) => onHandleDiscountTypeChange(value)}
                          options={[
                            { label: "%", value: "%" },
                            { label: "BDT", value: "BDT" },
                          ]}
                          className="w-full"
                        />
                      </div>
                    </div>
                  </div>
                </div>

                {/*Food Tax And Discount*/}
                <div className="pl-[20px] pr-6">
                  <FoodTaxAndDiscount
                    records={{
                      isVatApplicable,
                      setIsVatApplicable,
                      isDiscountApplicable,
                      setIsDiscountApplicable,
                      isSupplementaryDutyApplicable,
                      setIsSupplementaryDutyApplicable,
                      supplementaryDuty,
                      setSupplementaryDuty,
                    }}
                  />
                </div>

                <div className="flex flex-col pl-[25px] pb-[20px] pr-[25px]">
                  <div className="flex w-full mt-[10px]">
                    <div className="ml-auto flex items-center gap-[10px]" style={{ width: "49%" }}>
                      <div className="flex-[5]">
                        <Button
                          type="primary"
                          onClick={resetComboMenu}
                          className="w-full mt-[16px] h-[40px] text-white border-none"
                          style={{
                            backgroundColor: "#FFD700",
                            color: "#000000",
                            fontFamily: "ubold",
                          }}
                        >
                          Cancel
                        </Button>
                      </div>

                      <div className="flex-[5]">
                        <Button
                          type="primary"
                          disabled={upsertLoading} // ✅ disables button during loading
                          onClick={onClickSaveComboMenu}
                          className="w-full mt-[16px] h-[40px] text-white border-none"
                          style={{
                            backgroundColor: "#000000",
                            color: "#FFFFFF",
                            fontFamily: "ubold",
                          }}
                        >
                          {upsertLoading ? <Spin size={"small"} /> : "Save"}
                        </Button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <ConfirmationModal
            openModal={isConfirmModalOpen}
            records={{
              onFinish: onConfirm,
              onCancel: onNotConfirm,
              action: action,
              message: confirmationMessage,
              param: selectedItem,
            }}
          />
          <ViewFoodModal
            openModal={isViewModalOpen}
            records={{
              onFinish: onCloseViewModal,
              onCancel: onCloseViewModal,
              param: selectedItem,
            }}
          />
        </div>
      </div>
    </div>
  );
}

export default SetMenu;
